/**
 * 模板管理状态
 * 通过后端 API 按账号+接口维度存储字段配置模板
 */
import { create } from 'zustand';
import http from '../api/http.js';
import { isLogin } from '../utils/auth.js';
import sha256 from 'crypto-js/sha256';
import { DEFAULT_RESULT_URL } from '../const/constants.js';

const MAX_TEMPLATES = 10;

function getSid() {
  const { QCLogin } = window;
  const uin = QCLogin?.getUin();
  return uin ? sha256(uin).toString() : '';
}

export const useTemplateStore = create((set, get) => ({
  templates: [],
  currentTemplateName: '',
  loading: false,

  // 查询指定接口的模板列表
  loadTemplatesByAction: async (actionName) => {
    const { QCLogin } = window;
    if (!QCLogin || !QCLogin.isLogin()) {
      set({ templates: [], currentTemplateName: '' });
      return;
    }
    set({ loading: true });
    try {
      const res = await http.post({
        url: DEFAULT_RESULT_URL,
        cmd: 'QueryInterfaceTemplatesForDemo',
        data: {
          Sid: getSid(),
          InterfaceName: actionName,
        },
        checkLogin: false,
      });
      if (!res.error && res.Templates) {
        set({ templates: res.Templates, currentTemplateName: '' });
      } else {
        set({ templates: [], currentTemplateName: '' });
      }
    } catch {
      set({ templates: [], currentTemplateName: '' });
    } finally {
      set({ loading: false });
    }
  },

  // 保存当前配置为模板
  saveTemplate: async (actionName, name, fields) => {
    const loggedIn = await isLogin();
    if (!loggedIn) return { success: false, message: '请先登录' };

    const { templates } = get();
    if (templates.length >= MAX_TEMPLATES) {
      return { success: false, message: `模板上限 ${MAX_TEMPLATES} 个` };
    }
console.log('[Template] saveTemplate fields:', fields);
    try {
      const res = await http.post({
        url: DEFAULT_RESULT_URL,
        cmd: 'CreateInterfaceTemplateForDemo',
        data: {
          Sid: getSid(),
          InterfaceName: actionName,
          Name: name,
          Content: JSON.stringify(fields),
        },
        checkLogin: false,
      });
      console.log('[Template] CreateInterfaceTemplateForDemo res:', res);
      if (!res.error) {
        // 重新加载模板列表
        await get().loadTemplatesByAction(actionName);
        return { success: true };
      }
      return { success: false, message: res.message || '保存失败' };
    } catch (e) {
      return { success: false, message: '保存失败' };
    }
  },

  // 删除模板
  deleteTemplate: async (actionName, name) => {
    const loggedIn = await isLogin();
    if (!loggedIn) return { success: false };

    try {
      await http.post({
        url: DEFAULT_RESULT_URL,
        cmd: 'DeleteInterfaceTemplateForDemo',
        data: {
          Sid: getSid(),
          InterfaceName: actionName,
          Name: name,
        },
        checkLogin: false,
      });
      // 重新加载模板列表
      await get().loadTemplatesByAction(actionName);
      return { success: true };
    } catch {
      return { success: false };
    }
  },

  // 选择模板
  selectTemplate: (name) => {
    set({ currentTemplateName: name });
  },

  // 获取模板数据（解析 Content）
  getTemplateData: (name) => {
    const { templates } = get();
    const tpl = templates.find((t) => t.Name === name);
    if (!tpl) return null;
    try {
      return { name: tpl.Name, fields: JSON.parse(tpl.Content) };
    } catch {
      return { name: tpl.Name, fields: [] };
    }
  },
}));
